import React from 'react';
import {
  Paper,
  Typography,
  Box,
  Card,
  CardContent,
  Divider
} from '@mui/material';
import { School as SchoolIcon } from '@mui/icons-material';

const EducationView = ({ education = [] }) => {
  if (!education || education.length === 0) {
    return (
      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>Education</Typography>
        <Typography variant="body2" color="text.secondary">
          No education added yet.
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>Education</Typography>
      
      {education.map((edu, index) => (
        <Box key={edu.id}>
          <Card sx={{ mb: 2 }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                <SchoolIcon color="primary" sx={{ mt: 0.5 }} />
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h6">{edu.degree}</Typography>
                  <Typography variant="subtitle1" color="text.secondary">
                    {edu.institutionName}
                  </Typography>
                  {edu.fieldOfStudy && (
                    <Typography variant="body2" color="text.secondary">
                      {edu.fieldOfStudy}
                    </Typography>
                  )}
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    {edu.startDate} - {edu.current ? 'Present' : edu.endDate}
                  </Typography>
                  {edu.gpa && (
                    <Typography variant="body2" color="text.secondary">
                      GPA: {edu.gpa}
                    </Typography>
                  )}
                  {edu.description && (
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      {edu.description}
                    </Typography>
                  )}
                </Box>
              </Box>
            </CardContent>
          </Card>
          {index < education.length - 1 && <Divider sx={{ my: 2 }} />}
        </Box>
      ))}
    </Paper>
  );
};

export default EducationView; 